import { Stack } from '@workramp/ui';
import styled from 'styled-components';

export const LearnerSearchItemStyledStack = styled(Stack)`
  margin-top: -2px;
`;

export const AutocompleteFieldContainer = styled.div<{
  $isFocused?: boolean;
}>`
  @media (max-width: 600px) {
    position: ${({ $isFocused }) => ($isFocused ? 'absolute' : 'relative')};
    left: ${({ $isFocused, theme }) => ($isFocused ? `${theme.spacing(5)}px` : '0')};
    right: ${({ $isFocused, theme }) => ($isFocused ? `${theme.spacing(5)}px` : '0')};
    top: ${({ $isFocused, theme }) => ($isFocused ? `${theme.spacing(3)}px` : '0')};
  }
`;
